import { ENTRY_POINTS } from '@legate/shared';
import { Section } from './Section.js';

const INITIATOR_LABEL: Record<'user' | 'business', string> = {
  user: 'User',
  business: 'Business',
};

export function SolutionsSection() {
  return (
    <Section
      id="solutions"
      label="Solutions"
      title={
        <>
          The permitted
          <br className="hidden sm:block" /> entry map
        </>
      }
      intro="On Instagram and Messenger a business cannot start a conversation. The user always does. The inbox is a conversion channel, not a cold-touch channel."
    >
      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[560px] text-left border-collapse">
          <thead>
            <tr className="border-y border-hairline">
              <th className="py-3 pr-6 text-[11px] uppercase tracking-[0.2em] text-ink/50 font-medium w-[30%]">
                Channel
              </th>
              <th className="py-3 pr-6 text-[11px] uppercase tracking-[0.2em] text-ink/50 font-medium w-[16%]">
                Initiated by
              </th>
              <th className="py-3 text-[11px] uppercase tracking-[0.2em] text-ink/50 font-medium">
                What it gives
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-hairline">
            {ENTRY_POINTS.map((entry) => (
              <tr key={entry.key} className="align-top">
                <td className="py-4 pr-6 text-sm font-medium text-ink">
                  {entry.label}
                  {entry.paid ? (
                    <span className="ml-2 text-[11px] text-ink/40 whitespace-nowrap">paid</span>
                  ) : null}
                </td>
                <td className="py-4 pr-6 text-sm text-ink/70">
                  {INITIATOR_LABEL[entry.initiatedBy]}
                  {entry.requiresOptIn ? (
                    <span className="block text-[11px] text-ink/40 mt-1">opt-in on record</span>
                  ) : null}
                </td>
                <td className="py-4 text-sm text-ink/70 leading-relaxed">{entry.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-10 sm:mt-12 grid md:grid-cols-2 gap-6 md:gap-16">
        <p className="text-sm md:text-[15px] text-ink/70 leading-relaxed">
          First contact therefore lives in three places, all of them permitted and all of them
          scalable: paid click-to-Messenger and click-to-WhatsApp ads, WhatsApp templates sent
          against a recorded opt-in, and email.
        </p>
        <p className="text-sm md:text-[15px] text-ink/70 leading-relaxed">
          Everything organic — comment-to-DM, story replies, Ice Breakers — converts attention that
          already exists. The runtime knows which of the two it is holding, and refuses the wrong
          move before the message is written.
        </p>
      </div>
    </Section>
  );
}

export default SolutionsSection;
